import React, { useState } from 'react';
import PropTypes from 'prop-types';
// utils
import { useGetTreatment } from 'src/hooks/useGetTreatment';
// components
import CustomWidgetCard from './CustomWidgetCard';

const TaskReportWidget = ({ onWidgetClick }) => {
    const [currentWidget, setCurrentWidget] = useState('');

    const { getTreatmentId } = useGetTreatment();

    const widgetArray = [
        { key: 'Total', icon: '', value: '0', text: 'Total Task' },
        { key: 'Invisalign', icon: '', value: 'invisalign', text: 'Task for Invisalign', isTreatment: true },
        { key: 'Bonding', icon: '', value: 'bonding', text: 'Task for Bonding', isTreatment: true },
        { key: 'Implants', icon: '', value: 'implants', text: 'Task for Implants', isTreatment: true },
        { key: 'Whitening', icon: '', value: 'whitening', text: 'Task for Whitening', isTreatment: true },
    ];

    const handleWidgetClick = (value, key) => {
        setCurrentWidget(key);
        const treatmentId = getTreatmentId(value);
        onWidgetClick(treatmentId);
    };

    return (
        <CustomWidgetCard handleWidgetClick={handleWidgetClick} widgetArray={widgetArray} currentWidget={currentWidget} isTaskWidget />
    );
};

export default TaskReportWidget;

TaskReportWidget.propTypes = {
    onWidgetClick: PropTypes.func,
};
